import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { LangText } from '@/components'
import { preFixImgUrl } from '@/utils'
import { SparkleTitle, TITLE_GRADIENT } from '../HanedaShop'
import useModel, { type QuickLinkItem } from './useModel'

const VIP_EXPERIENCE_FLOW_BG = 'b679f227d317a0556b9bcdd6936a5de5.png'

const VIP_WAKO_BOOKING =
  'https://vip.japanmall.com/?fc=wako01&sc=0303#/pages/home/index'

/** 序号图：`/...` 或 `https?://` 原样；否则走 CDN */
const vipExperienceNumSrc = (numImage: string) =>
  numImage.startsWith('/') || numImage.startsWith('http') ? numImage : preFixImgUrl(numImage)

/** 立即体验：序号位图；可换为 `xxx.png` 经 preFixImgUrl 或继续用 public 下 svg */
const VIP_EXPERIENCE_CARDS: {
  numImage: string
  titleKey: string
  imgFile: string
  ctaEnabled: boolean
  href?: string
}[] = [
  {
    numImage: '8c9442a7607831385e376fe201bc4875.png',
    titleKey: '09d495e3',
    imgFile: 'daf436e8cdf9ffb906acbfb0b24e7274.png',
    ctaEnabled: true,
    href: VIP_WAKO_BOOKING,
  },
  {
    numImage: '72ee010be0c3afe4a63654f7e50df88c.png',
    titleKey: '9e780417',
    imgFile: 'acf7e4eb7e96adff3f1608109b137ef5.png',
    ctaEnabled: false,
  },
  {
    numImage: 'd2583705bf2be6a102c9fa66b1d593c4.png',
    titleKey: '81bbb386',
    imgFile: '69a7d35df2eb359fa4e768f2d713f143.png',
    ctaEnabled: false,
  },
]

/** 左→右、上→下 与网格顺序一致 */
const VIP_RIGHT_SERVICES: { lngKey: string; img: string }[] = [
  { lngKey: '527c3183', img: 'https://static.xyb2b.com/images/93818ebdd45485f6e56d95e6834c3788.png' },
  { lngKey: 'f9a12794', img: 'https://static.xyb2b.com/images/3448b526025d52f61b723188e3c93255.png' },
  { lngKey: '14ba7ae2', img: 'https://static.xyb2b.com/images/9a79ce1138be2b6d8992718c3a4e12dc.png' },
  { lngKey: '032751c0', img: 'https://static.xyb2b.com/images/37981aad33257932a2e59076de495f5e.png' },
  { lngKey: '4f4428fe', img: 'https://static.xyb2b.com/images/5710cb8aef3b286aee48342109889b77.png' },
  { lngKey: '8b0d3c1d', img: 'https://static.xyb2b.com/images/d2e3a45b3f537f732e99e9f93c286a74.png' },
]

const Vip = () => {
  const { t } = useTranslation()
  const { serviceFeatureScreens, quickLinks } = useModel()

  return (
    <div className="flex flex-col">
      {/* Hero */}
      <div
        className="relative min-h-[480px] flex flex-col items-center justify-center px-6 py-20 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${preFixImgUrl('e57eb82b61e639b58259766b024e48f5.png')})` }}
      >
        <div className="flex relative z-10 flex-col items-center mx-auto max-w-3xl text-center">
          <LangText lngKey="e10ddb3e" className="text-white text-[40px] md:text-[44px] font-bold leading-tight px-2">
            {t('e10ddb3e')}
          </LangText>
          <LangText lngKey="0ea28797" className="text-white text-[17px] md:text-[18px] leading-relaxed mt-6 px-2">
            {t('0ea28797')}
          </LangText>
          {/* <div className="flex flex-wrap gap-5 justify-center mt-10">
            <div
              className="h-[48px] min-w-[140px] px-10 flex items-center justify-center rounded-full text-white text-[17px] cursor-pointer transition-opacity hover:opacity-90"
              style={{ background: 'linear-gradient(270deg, #A75AFF 0%, #4B51FF 100%)' }}
              onClick={() => window.open('https://vip.japanmall.com/?fc=wako01&sc=0303#/pages/home/index')}
            >
              <LangText lngKey="bcc799b1">{t('bcc799b1')}</LangText>
            </div>
          </div> */}
        </div>
      </div>

      <div className="bg-[#F8F6FF] overflow-visible">
        {/* 日本顶级尊享体验 */}
        <section className="py-[60px] overflow-visible">
          <div className="overflow-visible">
            <div className='mx-auto text-center w-8xl md:px-10'>
              <SparkleTitle lngKey="60ca6999" purpleTitle />
            </div>

            {/* 与底图同比例（1024×359）；三栏百分比与左右白卡、中间光球对齐（图2） */}
            <div className="overflow-visible mx-auto mt-10 max-w-10xl">
              <div className="overflow-visible relative">
                {/* 高度仅由宽高比决定；子层全部脱离文档流，避免小屏被内容撑高后跨断点「突然变矮」导致底图缩放跳变 */}
                <div className="@container relative w-full aspect-[1424/500] overflow-visible max-lg:rounded-t-[24px]">
                  <div
                    aria-hidden
                    className="pointer-events-none absolute inset-0 bg-center bg-no-repeat max-lg:rounded-t-[24px]"
                    style={{
                      backgroundImage: `url(${preFixImgUrl(VIP_EXPERIENCE_FLOW_BG)})`,
                      backgroundSize: '100% 100%',
                    }}
                  />
                  {/* 全宽始终左-中-右三列，与底图一致；小屏靠 cqw 缩小字号而非改竖排 */}
                  {/* 勿用 overflow-hidden：左/右 mt-[-32px]、中间 top-[-20px] 会画出格，hidden 会裁顶；勿用 overflow-x-clip+visible-y（规范会把 y 变成 auto 继续裁切） */}
                  <div className="absolute inset-0 z-10 grid min-h-0 min-w-0 grid-cols-[minmax(0,24%)_minmax(0,52%)_minmax(0,24%)] grid-rows-1 gap-0 overflow-visible px-[3%] pb-[4.2%] pt-[2%] sm:px-[8%] md:px-[12%] lg:px-[15%]">
                    {/* 左：标题在白卡上方；渐变+副文案在底图钻石下方、白卡内（字号/间距随横幅 cqw 缩放） */}
                    <div className="flex flex-col min-w-0 h-full min-h-0 mt-[-32px]">
                      <div className="text-center shrink-0">
                        <LangText
                          lngKey="12c20332"
                          className="text-[24px] text-transparent bg-clip-text bg-gradient-to-r from-[#4B51FF] to-[#A75AFF]"
                        >
                          {t('12c20332')}
                        </LangText>
                        <div
                          className="mx-auto mt-[clamp(4px,0.45cqw,7px)] h-0 w-0 border-x-[clamp(4px,0.5cqw,6px)] border-x-transparent border-t-[clamp(5px,0.6cqw,7px)] border-t-[#A75AFF] opacity-50"
                          aria-hidden
                        />
                      </div>
                      <div className="mt-[clamp(4px,0.8cqw,8px)] flex min-h-0 min-w-0 flex-1 flex-col justify-start gap-[clamp(0.5rem,1.2cqw,0.85rem)] px-0 pb-[7%] pt-[95%]">
                        <div
                          className="rounded-[10px] px-[20px] py-[clamp(8px,1.35cqw,12px)] text-center text-[clamp(10px,1.12cqw,14px)] font-medium leading-snug"
                          style={{
                            background: 'linear-gradient(270deg, #A75AFF, #4B51FF)',
                          }}
                        >
                          <LangText
                            lngKey="b28584e9"
                            className="text-[18px] text-transparent bg-clip-text bg-gradient-to-b from-[#F8EDDB] to-[#FFD0A2]"
                          >
                              {t('b28584e9')}
                          </LangText>
                        </div>
                        <LangText
                          lngKey="44c497c6"
                          className="text-center text-[20px] leading-[1.4] text-transparent bg-clip-text bg-gradient-to-r from-[#4B51FF] to-[#A75AFF] mt-2"
                        >
                          {t('44c497c6')}
                        </LangText>
                      </div>
                    </div>

                    {/* 中：顶在光球上方；AI 胶囊贴光球下缘（图2） */}
                    <div className="relative min-w-0 h-full min-h-0">
                      <div className="absolute left-1/2 top-[-20px] z-20 flex w-full -translate-x-1/2 flex-col items-center gap-[clamp(4px,0.55cqw,7px)]">
                        <div className="flex justify-center items-end">
                          <img
                            src={preFixImgUrl('deac3fde95a42bc15c235651f1d494bf.png')}
                            alt=""
                            className="h-[60px] w-auto object-contain object-bottom"
                          />
                        </div>
                        <LangText
                          lngKey="e26686df"
                          className="text-center text-[20px] text-transparent bg-clip-text bg-gradient-to-r from-[#4B51FF] to-[#A75AFF]"
                        >
                          {t('e26686df')}
                        </LangText>
                      </div>
                      <div
                        className="absolute top-[95%] left-1/2 z-20 w-[320px] -translate-x-1/2 -translate-y-[29%]"
                      >
                        <div
                          className="flex min-w-0 flex-row flex-nowrap items-center gap-[clamp(8px,1.1cqw,14px)] rounded-full px-[clamp(10px,1.8cqw,14px)] py-[clamp(8px,1.2cqw,12px)]"
                          style={{
                            background: 'linear-gradient(180deg, #F0EDFF, #FCFBFF)',
                            boxShadow: '3px 12px 14px 0px rgba(235,231,255,0.34)',
                          }}
                        >
                          <span className="flex size-[clamp(36px,4.5cqw,48px)] shrink-0 items-center justify-center rounded-full bg-white shadow-[0_2px_8px_rgba(93,92,222,0.12)]">
                            <img
                              src={preFixImgUrl('56dadebd087028620fa5ed62f9e1529a.png')}
                              alt=""
                              className="size-[72%] object-contain"
                            />
                          </span>
                          <LangText
                            lngKey="ec27ae5d"
                            className="min-w-0 flex-1 text-left text-[clamp(10px,1.05cqw,16px)] leading-[1.4] text-[#333333]"
                          >
                            {t('ec27ae5d')}
                          </LangText>
                        </div>
                      </div>
                    </div>

                    {/* 右：标题在白卡上方；网格铺满右侧白卡（无底图钻石，顶距小于左侧） */}
                    <div className="flex flex-col min-w-0 h-full min-h-0 mt-[-32px]">
                      <div className="text-center shrink-0">
                        <LangText
                          lngKey="9e2dd3fc"
                          className="text-[24px] text-[24px] text-transparent bg-clip-text bg-gradient-to-r from-[#4B51FF] to-[#A75AFF]"
                        >
                          {t('9e2dd3fc')}
                        </LangText>
                        <div
                          className="mx-auto mt-[clamp(4px,0.45cqw,7px)] h-0 w-0 border-x-[clamp(4px,0.5cqw,6px)] border-x-transparent border-t-[clamp(5px,0.6cqw,7px)] border-t-[#A75AFF] opacity-50"
                          aria-hidden
                        />
                      </div>
                      {/* 插图占格子的固定比例（%），随右栏变宽变窄与底图白卡一致；文案用横幅 @container 的 cqw */}
                      <div className="flex flex-col flex-1 justify-center min-w-0 min-h-0">
                        <div className="grid min-w-0 grid-cols-2 gap-x-[6%] gap-y-[9%]">
                          {VIP_RIGHT_SERVICES.map(({ lngKey, img }) => (
                            <div
                              key={lngKey}
                              className="flex min-w-0 flex-col items-center gap-[4%] text-center"
                            >
                              <span className="flex w-[68%] max-w-full items-center justify-center">
                                <img
                                  src={preFixImgUrl(img)}
                                  alt=""
                                  className="object-contain w-full h-auto"
                                />
                              </span>
                              <LangText
                                lngKey={lngKey}
                                className="w-full min-w-0 text-[clamp(9px,0.985cqw,14px)] leading-tight text-[#333333]"
                              >
                                {t(lngKey)}
                              </LangText>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 服务特色 */}
        <section className="mt-[10px] pb-[40px] md:pb-[60px]">
          <div className="px-6 mx-auto w-8xl md:px-10">
            <SparkleTitle lngKey="bc90c8e2" purpleTitle />
            <div className="mt-10 mb-8 rounded-[28px] bg-white shadow-[0_8px_40px_rgba(0,0,0,0.08)] px-6 py-10 md:px-12 md:py-14">
              <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-5 lg:gap-6">
                {serviceFeatureScreens.map((item) => (
                  <div key={item.titleKey} className="flex flex-col items-center text-center">
                    <div className="w-full max-w-[200px] mx-auto">
                      <img src={item.img} alt="" className="object-cover w-full h-auto rounded-xl" />
                    </div>
                    <div className="flex flex-col gap-2 items-center mt-6">
                      <LangText
                        lngKey={item.titleKey}
                        className={`font-bold leading-tight text-[16px] md:text-[16px] ${TITLE_GRADIENT}`}
                      >
                        {t(item.titleKey)}
                      </LangText>
                      <LangText
                        lngKey={item.subKey}
                        className="text-[14px] md:text-[14px] font-normal leading-tight text-[#1D1D1D]"
                      >
                        {t(item.subKey)}
                      </LangText>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* 立即体验 */}
        <section className="pb-[60px]">
          <div className="px-6 mx-auto w-8xl md:px-10">
            <SparkleTitle lngKey="be730b5d" purpleTitle />
            <div className="grid grid-cols-3 gap-8 mt-10">
              {VIP_EXPERIENCE_CARDS.map(({ numImage, titleKey, imgFile, ctaEnabled, href }) => {
                const ctaClass =
                  'inline-flex w-fit shrink-0 items-center justify-center self-center rounded-full py-4.5 px-16 text-center text-[20px] font-medium transition-opacity';
                return (
                  <div
                    key={titleKey}
                    className="flex overflow-hidden relative flex-col px-6 py-10 h-full min-h-0 bg-white rounded-2xl"
                  >
                    <img
                      src={vipExperienceNumSrc(numImage)}
                      alt=""
                      className="pointer-events-none mx-auto h-[48px] w-auto max-w-full select-none object-contain"
                      aria-hidden
                    />
                    <LangText
                      lngKey={titleKey}
                      className={`mt-1 font-bold leading-snug text-center text-[24px] ${TITLE_GRADIENT}`}
                    >
                      {t(titleKey)}
                    </LangText>
                    <div className="flex min-h-[140px] flex-1 items-center justify-center py-10">
                      <img
                        src={preFixImgUrl(imgFile)}
                        alt=""
                        className="h-auto max-h-[180px] w-auto max-w-full object-contain"
                      />
                    </div>
                    {ctaEnabled && href ? (
                      <a
                        href={href}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={`text-white no-underline ${ctaClass} hover:opacity-90`}
                        style={{
                          background: 'linear-gradient(90deg, #5A5EFA 0%, #9E7BFF 100%)',
                        }}
                      >
                        <LangText lngKey="bcc799b1">{t('bcc799b1')}</LangText>
                      </a>
                    ) : (
                      <button
                        type="button"
                        disabled
                        className={`${ctaClass} cursor-not-allowed border-0 bg-[#E5E7EB] text-[#9CA3AF]`}
                      >
                        <LangText lngKey="51e0ae4d">{t('51e0ae4d')}</LangText>
                      </button>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        {/* 快捷入口：用户条款 /items，联系我们 mailto */}
        <section className="pt-12 pb-16 bg-[#FFF]">
          <div className="px-6 mx-auto w-2xl md:px-10">
            <div className="grid grid-cols-2 gap-2 w-full">
              {quickLinks.map((item: QuickLinkItem) => {
                const cardClass =
                  'flex flex-col gap-4 items-center min-w-0 text-center cursor-pointer transition-opacity hover:opacity-90 text-inherit no-underline';
                const inner = (
                  <>
                    <span className="w-[88px] h-[88px] flex items-center justify-center">
                      <img src={item.iconImg} alt="" className="object-contain max-w-full max-h-full" />
                    </span>
                    <LangText lngKey={item.key} className="text-[18px] text-[#333333] font-bold">
                      {t(item.key)}
                    </LangText>
                  </>
                );
                if ('href' in item) {
                  return (
                    <a key={item.key} href={item.href} className={cardClass}>
                      {inner}
                    </a>
                  );
                }
                return (
                  <Link key={item.key} to={item.to} className={cardClass}>
                    {inner}
                  </Link>
                );
              })}
            </div>
          </div>
        </section>
      </div>
    </div>
  )
}

export default Vip
